<template>
  <input
    type="radio"
    :class="[
      $style.checkbox,
      {
        [$style['checkbox--checked']]: modelValue === value,
        [$style['checkbox--disabled']]: disabled,
      },
    ]"
    :name="name"
    :value="value"
    :checked="modelValue === value"
    :disabled="disabledValue"
    @change="emit('update:modelValue', value)"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { OptionValueType } from '@/types/app'

const props = withDefaults(
  defineProps<{
    name: string
    modelValue?: OptionValueType
    value?: OptionValueType
    disabled?: boolean
  }>(),
  {
    modelValue: null,
    value: null,
    disabled: false,
  }
)

const emit = defineEmits<{
  (event: 'update:modelValue', value: OptionValueType): void
}>()

const disabledValue = computed(
  (): true | undefined => props.disabled || undefined
)
</script>

<style lang="scss" module>
.checkbox {
  $checkbox: &;

  position: relative;
  width: 24px;
  height: 24px;
  appearance: none;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('~@/assets/images/icons/radiobutton-off.svg');
    background-size: cover;
    content: '';
  }

  &--checked {
    &::before {
      background-image: url('~@/assets/images/icons/radiobutton-on.svg');
    }

    &#{$checkbox}--disabled::before {
      background-image: url('~@/assets/images/icons/radiobutton-on-disabled.svg');
    }
  }

  &--disabled::before {
    background-image: url('~@/assets/images/icons/radiobutton-off-disabled.svg');
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }
}
</style>
